import { render, staticRenderFns } from "./CollectionChat.vue?vue&type=template&id=8c3f867c"
import script from "./CollectionChat.vue?vue&type=script&lang=js"
export * from "./CollectionChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports